const getWidthStyles = (s, t) => {
  let maxWidth = "", width = "auto";
  return s !== "auto" && (width = `${t.sizes.modal[s]}px`), ["xxxl", "xxl", "xl", "lg", "auto"].includes(s) && (maxWidth = "initial"), { width, maxWidth };
}, sizeStyles = (t, s, fullFrameMobile) => {
  let styles = {};
  if (typeof s == "string")
    styles = getWidthStyles(s, t);
  else
    for (const [displaySize, size] of Object.entries(s)) {
      const { width, maxWidth } = getWidthStyles(size, t);
      styles[t.breakpoints.up(displaySize)] = {
        width,
        maxWidth
      };
    }
  return fullFrameMobile && (styles[t.breakpoints.only("xs")] = {
    width: "100%",
    maxWidth: "100%",
    height: "100%"
  }), styles;
};
export {
  sizeStyles
};
//# sourceMappingURL=utils.js.map
